import React from 'react'
import Header from '../Header/header'
import Offer from '../Offer/offer'
import About from '../About/about'
import Projects from '../Projects/projects'
import PartnersContent from '../Partners/partnersContent'

export default class Home extends React.Component {
  render () {
    return (
      <div>
        <Header />
        <Offer />
        <About />
        <Projects />

        <div class='partners_content'>
          <PartnersContent />
        </div>
      </div>
    )
  }
}

